<template>
    <v-layout row justify-center>
        <v-flex v-if="visible">
            <div class="xs-12 mx-5 my-3" v-html="content"></div>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "HTMLInfo",

        data () {
            return {
                content: "",
                visible: false
            }
        }
    }
</script>
